const config = {
	name: 'Jijin',
	title: "Hi I'm Jijin 👋🏻",
	blog: 'Dev', // Dev.to or Medium (Make blank if you don't need the blog)

	// Social media profile username
	github: 'pjijin', // [REQUIRED] Github Username
	twitter: 'pjijin', // Twitter Username
	stackoverflow: '3211944', // Eg: 3211944
	medium: '', // without @ symbol
	instagram: '',
	dev: 'pjijin',
	youtube: '', // Channel ID
	linkedin: ''
};

export { config };
